import React from 'react';
import { Card, CardContent, CardHeader, Typography, Grid, List, ListItem, Avatar, ListItemText, ListItemAvatar } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';
import moment from 'moment';

//services
import PromocaoAPI from '../../../services/api/Promocao';

import './promocao.css';

import compraIcon from './money.svg';
import cupomIcon from './tickets.svg';
import winIcon from './giftbox.svg';

import emptyImg from './empty.png';

export default class Promocao extends React.Component {
	state = {
		titulo: null,
		descricao: null,
		data_inicio: null,
		data_fim: null,
		img: null,
		data_cadastro:null,
		premios:[],

		loading: true,
	}

	refreshPromocao = () => {
		const { id } = this.props.match.params;
		PromocaoAPI.get_web(id)
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({
					titulo: res.titulo,
					valor_cupom: res.valor_cupom,
					data_inicio: res.data_inicio,
					data_fim: res.data_fim,
					logo: res.logo,
					regulamento: res.regulamento,
					background: res.background,
					data_cadastro: res.data_cadastro,
					premios: res.premios,

					loading:false,
				 })
				return;
			})
		});
	}

	componentDidMount(){
		this.refreshPromocao()
	}
    render() {
		const { titulo, valor_cupom, data_inicio, data_fim, logo, background, regulamento, loading, premios } = this.state;
		const { PUBLIC_URL } = process.env;
		const { pathname } = this.props.location;
		if( loading ){ return <LoadBox loading={loading} height="50vh" /> }
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>{`${titulo} - Promoções`}</title>
						<meta property="og:locale" content="pt_BR" />
						<meta property="og:url" content={`${PUBLIC_URL}${pathname}`} />
						<meta property="og:title" content={titulo} />
						<meta property="og:site_name" content="Shopping Norte Sul" />
						<meta property="og:image" content={logo} />
						<meta property="og:type" content="website" />
					</Helmet>
					<div className="image_background" style={{backgroundImage:`url(${background})`}} >
						<div className="logo_event" >
							<img src={logo} alt="" />
						</div>
						<div className="body_promocao" >
							<Card className="card__promocao" >
								<CardHeader className="title" title="Como participar?" />
								<CardContent>
									<Grid container spacing={16} className="promocao_participar" >
										<Grid item xs={12} md={4} className="participar_item" >
											<Avatar style={{width:120, height: 120, padding: 10, backgroundColor:'#F1F1F1'}} >
												<img src={compraIcon} alt="" />
											</Avatar>
											<Typography>A CADA R$ {valor_cupom} EM COMPRAS</Typography>
										</Grid>
										<Grid item xs={12} md={4} className="participar_item" >
											<Avatar style={{width:120, height: 120, padding: 10, backgroundColor:'#F1F1F1'}} >
												<img src={cupomIcon} alt=""/>
											</Avatar>
											<Typography>VOCÊ GANHA 1 CUPOM</Typography>
										</Grid>
										<Grid item xs={12} md={4} className="participar_item" >
											<Avatar style={{width:120, height: 120, padding: 10, backgroundColor:'#F1F1F1'}} >
												<img src={winIcon} alt=""/>
											</Avatar>
											<Typography>CONCORRA A PRÊMIOS DE {moment(data_inicio).format("DD/MM/YYYY")} à {moment(data_fim).format("DD/MM/YYYY")}</Typography>
										</Grid>
									</Grid>
								</CardContent>
								<CardHeader className="title" title="Prêmios" />
								<CardContent>
									<List>
										{premios.map((p,k) => <ListItem key={k} >
											<ListItemAvatar>
												<Avatar style={{width:65, height: 65, padding: 10}} >
													<img src={emptyImg} alt="" width="70%" />
												</Avatar>
											</ListItemAvatar>
											<ListItemText primary={p.nome} secondary={`Quantidade: ${p.quantidade}`} />
										</ListItem>)}
									</List>
								</CardContent>
								<CardHeader className="title" title="Regulamento" />
								<CardContent>
									<object width="100%" height="500" data={`${regulamento}?#zoom=150&scrollbar=1&toolbar=1&navpanes=1`} type="application/pdf"></object>
								</CardContent>
							</Card>
						</div>
					</div>
				</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/web/pages/promocoes/promocao.js